import * as React from "react";
import { useTranslation } from "hooks";
import { Content, Typography, VisuallyHidden } from "components";
import layoutImage from "./assets/layout.png";
import title from "./assets/title.svg";
import styles from "./NoAccess.module.css";

interface NoAccessProps {
  failedLicense: "scope" | "packageAssessment";
}
const NoAccess: React.FC<NoAccessProps> = ({ failedLicense }) => {
  const { t } = useTranslation();

  return (
    <Content className={styles.wrapper}>
      <div className={styles.message}>
        <VisuallyHidden>
          <Typography component="h1">{t("noAccess.noAccess")}</Typography>
        </VisuallyHidden>
        <Typography component="p" variant="h4" className={styles.subtitle}>
          {t("noAccess.missing")}
        </Typography>
        <img src={title} alt={t("noAccess.getAccess")} />
        <Typography component="p" variant="p2" className={styles.description}>
          {failedLicense === "scope" && t("noAccess.scopeAccess")}
          {failedLicense === "packageAssessment" && (
            <>
              {t("noAccess.packageAssessmentAccess")}{" "}
              <a href="http://stemscopes.com/" className={styles.link}>
                stemscopes.com
              </a>
            </>
          )}
        </Typography>
        <Typography component="p" variant="c2" className={styles.contact}>
          <a
            href="mailto:stemscopes@acceleratelearning.com"
            className={styles.link}
          >
            stemscopes@acceleratelearning.com
          </a>
          <br />
          <a href="tel:8005310864" className={styles.link}>
            800.531.0864
          </a>
        </Typography>
      </div>
      <div className={styles.imageHolder}>
        <img src={layoutImage} alt={t("noAccess.noAccess")} />
      </div>
    </Content>
  );
};

export default NoAccess;
